import React, { useState } from 'react'
import { animated, useSpring } from 'react-spring'
import Styles from './Card.module.css'

interface CardProps {
  image: string // Define the type of the image prop
}

const CardItem: React.FC<CardProps> = ({ image }) => {
  const [show, setShown] = useState<boolean>(false)

  const props3 = useSpring({
    transform: show ? 'scale(1.03)' : 'scale(1)',
    boxShadow: show ? '0 20px 25px rgb(0 0 0 / 25%)' : '0 2px 10px rgb(0 0 0 / 8%)'
  })

  return (
    <animated.div
      className={Styles.card}
      style={props3}
      onMouseEnter={() => setShown(true)}
      onMouseLeave={() => setShown(false)}
    >
      <img src={image} alt='card' />
    </animated.div>
  )
}

export default CardItem
